import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

const ONC_RENK: Record<string, string> = { 'Normal': '#3b82f6', 'Önemli': '#f59e0b', 'Acil': '#ef4444' };
const ONC_RGB: Record<string, string> = { 'Normal': '59,130,246', 'Önemli': '245,158,11', 'Acil': '239,68,68' };

@Component({
  selector: 'duyuru-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--duyuru" [style.--accent]="oncRenk()" [style.--accent-rgb]="oncRgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:10%;--y:20%"></span><span class="gc-p" style="--d:12s;--x:80%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:7s;--x:45%;--y:75%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">DUYURU</div>
        <div class="dy-ust">
          <div class="dy-baslik gc-baslik-ana">{{ p()?.baslik || 'Duyuru' }}</div>
          <div class="dy-oncelik-badge">{{ p()?.oncelik || 'Normal' }}</div>
        </div>
        @if (p()?.icerik) { <div class="dy-icerik">{{ p().icerik }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 50 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #ea580c; --accent-rgb: 234,88,12; }
    .dy-ust { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
    .dy-baslik { font-size: 13px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; }
    .dy-oncelik-badge { font-size: 8px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; padding: 2px 8px; border-radius: 2px; color: #fff; background: var(--accent); flex-shrink: 0; }
    .dy-icerik { font-size: 10px; color: var(--py-metin-ikincil, #64748b); line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  `],
})
export class DuyuruKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  oncRenk = computed(() => ONC_RENK[this.p()?.oncelik] || '#ea580c');
  oncRgb = computed(() => ONC_RGB[this.p()?.oncelik] || '234,88,12');
}
